export default (state = [], action) => {
  switch (action.type) {
    case "CREATE_ONBOARDING":
      return [...state, action.payload];
    case "FETCH_ONBOARDING":
      return [...state, action.payload];
    case "UPDATE_ONBOARDING":
      return [...state, action.payload];
    case "DELETE_ONBOARDING":
      return state.filter((item) => item && item._id !== action.payload);
    default:
      return state;
  }
};
